// extracted by mini-css-extract-plugin
export default {"title":"Wowu7","titleFacelift":"keCYa"};